"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var toWei = require('web3-utils').toWei;

var Pair_1 = __importDefault(require("./Pair"));

var toXdaiBridge = '0x4aa42145Aa6Ebf72e164C9bBC74fbD3788045016';
var toDaiBridge = '0x7301cfa0e1756b71869e93d4e4dca5c7d0eb0aa6';

var XDaiBridge =
/** @class */
function (_super) {
  __extends(XDaiBridge, _super);

  function XDaiBridge() {
    return _super.call(this, {
      assetA: 'xdai',
      assetB: 'dai'
    }) || this;
  }

  XDaiBridge.prototype.exchangeAtoB = function (_a) {
    var account = _a.account,
        value = _a.value,
        ether = _a.ether;

    var _value = this._getValue({
      value: value,
      ether: ether
    });

    var xdai = this.exchange.getAsset('xdai');
    return xdai.send({
      from: account,
      value: _value,
      to: toDaiBridge
    });
  };

  XDaiBridge.prototype.exchangeBtoA = function (_a) {
    var account = _a.account,
        value = _a.value,
        ether = _a.ether;

    var _value = this._getValue({
      value: value,
      ether: ether
    });

    var dai = this.exchange.getAsset('dai');
    return dai.send({
      from: account,
      value: _value,
      to: toXdaiBridge
    });
  };

  return XDaiBridge;
}(Pair_1.default);

exports.default = XDaiBridge;